import { call, put } from "redux-saga/effects";
import { Attraction } from "redmond";
import { fetchAttraction } from "../../../api/v0/availability/fetchAttraction";
import { actions } from "../actions";
import Logger from "../../../utils/logger";

export function* fetchAttractionSaga(action: actions.IFetchAttraction) {
  try {
    const attraction: Attraction | undefined = yield call(
      fetchAttraction,
      action.attractionId
    );
    yield put(actions.setSelectedAttraction(attraction));
  } catch (e) {
    Logger.debug(e);
    yield put(actions.setSelectedAttraction(undefined));
  }
}
